<template>
  <div
    class="assignment-detail"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <el-card class="head-tit" shadow="hover">上架单详情</el-card>
    <!-- 顶部商品信息 -->
    <!--<el-card shadow="hover" class="top-warp">-->
    <el-card shadow="hover" style="padding-left: 20px;position:relative;" class="top-warp">
      <div class="top-wrap_con">
        <label class="top-tit">
          <label>单据信息：</label>
          <label class="top-code">{{shelvesOrderInfo && shelvesOrderInfo.ysdCode}}</label>
        </label>
        <el-row style="padding-left: 40px">
          <el-col :span="8" class="assignment-content">
            <label>原库区：{{shelvesOrderInfo && shelvesOrderInfo.yaFromName}}</label>
            <label>供应商：{{shelvesOrderInfo && shelvesOrderInfo.supplierName}}</label>
            <label v-if="shelvesOrderInfo && shelvesOrderInfo.ysdSourceType === 0">来源：入库任务</label>
            <label v-if="shelvesOrderInfo && shelvesOrderInfo.ysdSourceType === 1">来源：手动创建</label>
            <label>创建人：{{shelvesOrderInfo && shelvesOrderInfo.createName}}</label>
          </el-col>
          <el-col :span="8" class="assignment-content">
            <label>原货位：{{shelvesOrderInfo && shelvesOrderInfo.ylFromCode}}</label>
            <label>SKU种数：{{shelvesOrderInfo && shelvesOrderInfo.ysdSkuNumber}}</label>
            <label>入库任务编号：{{shelvesOrderInfo && shelvesOrderInfo.ysdTaskCode || '-'}}</label>
            <label>创建日期：{{shelvesOrderInfo && shelvesOrderInfo.ysdCreateTime}}</label>
          </el-col>
          <el-col :span="8" class="assignment-content">
            <label v-if="shelvesOrderInfo && shelvesOrderInfo.ysdShelvesType === 0">状态：待上架</label>
            <label v-if="shelvesOrderInfo && shelvesOrderInfo.ysdShelvesType === 1">状态：部分上架</label>
            <label v-if="shelvesOrderInfo && shelvesOrderInfo.ysdShelvesType === 2">状态：已完成</label>
            <label v-if="shelvesOrderInfo && shelvesOrderInfo.ysdShelvesType === 3">状态：已取消</label>
            <label>总件数：{{shelvesOrderInfo && shelvesOrderInfo.ysdNumber}}件</label>
            <label>取消时间：{{shelvesOrderInfo && shelvesOrderInfo.ysdCancelTime}}</label>
            <label>完成日期：{{shelvesOrderInfo && shelvesOrderInfo.ysdFinishTime}}</label>
          </el-col>
        </el-row>
      </div>
      <el-button class="print-top-btn" @click="toPreviewPrint">打印上架单</el-button>
    </el-card>
    <!-- 商品列表信息 -->
    <el-card shadow="hover" class="assignmentedit-List">
      <label class="top-tit">商品信息</label>
      <el-tabs v-model="activeName">
        <el-tab-pane label="商品详情" name="first">
          <div v-if="shelvesOrderInfo" class="page-content-table">
            <div class="page-content-head">
              <div class="table-td vertical1">序号</div>
              <div class="table-td vertical2">商品名称</div>
              <div class="table-td vertical3">生产日期</div>
              <div class="table-td vertical5">
                <div>总数量</div>
                <div class="table-td-second">(正常品)</div>
              </div>
              <div class="table-td vertical6">
                <div>未上架(件)</div>
                <div class="table-td-second">(正常品)</div>
              </div>
              <div class="table-td vertical7">
                <div>已上架(件)</div>
                <div class="table-td-second">(正常品)</div>
              </div>
              <div class="table-td vertical8">
                <div>已取消(件)</div>
                <div class="table-td-second">(正常品)</div>
              </div>
              <div class="table-td vertical9">
                <div>中途出库(件)</div>
                <div class="table-td-second">(正常品)</div>
              </div>
              <div class="table-td vertical10">
                <div>总数量</div>
                <div class="table-td-second">(破损品)</div>
              </div>
              <div class="table-td vertical11">
                <div>未上架(件)</div>
                <div class="table-td-second">(破损品)</div>
              </div>
              <div class="table-td vertical12">
                <div>已上架(件)</div>
                <div class="table-td-second">(破损品)</div>
              </div>
              <div class="table-td vertical13">
                <div>已取消(件)</div>
                <div class="table-td-second">(破损品)</div>
              </div>
              <div class="table-td vertical14">
                <div>中途出库(件)</div>
                <div class="table-td-second">(破损品)</div>
              </div>
              <div class="table-td vertical15">
                <div>商品条码</div>
              </div>
            </div>
            <div class="page-content-body">
              <div
                v-for="(item, index) in shelvesOrderInfo.goodList"
                :key="index"
                class="page-content-body-list"
              >
                <div
                  v-for="(citem, cindex) in item.batchList"
                  :key="cindex"
                  class="page-content-body-item"
                >
                  <div class="table-td vertical1">
                    <span v-if="cindex == 0">{{ index + 1 }}</span>
                  </div>
                  <div class="table-td vertical2 text-one">
                    <span v-if="cindex == 0">{{ item.goodName }}</span>
                  </div>
                  <div class="table-td vertical3">
                    <span>{{ citem.ysdgProductionTime || '无' }}</span>
                  </div>
                  <!-- <div v-if="userInfo.isMdOpen==1" class="table-td vertical4">
                    <span :style="getValidUntil(citem.ysdgValidityTime).isPastDue ? 'color:red;':''">{{citem.ysdgValidityTime || '-'}}</span>
                  </div> -->
                  <div class="table-td vertical5">
                    <div>{{citem.allNum}}{{item.minUnit}}</div>
                    <div
                      class="table-td-second"
                    >({{ Math.floor(citem.allNum / item.box) }}{{item.maxUnit}}{{ citem.allNum % item.box }}{{item.minUnit}})</div>
                  </div>
                  <div class="table-td vertical6 vertical6-value">
                    <span>{{ citem.ysdgInventory }}</span>
                  </div>
                  <div class="table-td vertical7">
                    <span>{{ citem.ysdgShelves }}</span>
                  </div>
                  <div class="table-td vertical8">
                    <span>{{ citem.ysdgCancel }}</span>
                  </div>
                  <div class="table-td vertical9">
                    <span>{{ citem.ysdgOutbound }}</span>
                  </div>
                  <div class="table-td vertical10">
                    <div>{{citem.brokenAllNum}}{{item.minUnit}}</div>
                    <div
                      class="table-td-second"
                    >({{ Math.floor(citem.brokenAllNum / item.box) }}{{item.maxUnit}}{{ citem.brokenAllNum % item.box }}{{item.minUnit}})</div>
                  </div>
                  <div class="table-td vertical11 vertical11-value">
                    <span>{{ citem.ysdgBrokenInventory }}</span>
                  </div>
                  <div class="table-td vertical12">
                    <span>{{ citem.ysdgBrokenShelves }}</span>
                  </div>
                  <div class="table-td vertical13">
                    <span>{{ citem.ysdgBrokenCancel }}</span>
                  </div>
                  <div class="table-td vertical14">
                    <span>{{ citem.ysdgBrokenOutbound }}</span>
                  </div>
                  <div class="table-td vertical15">
                    <span v-if="cindex == 0">{{ item.barCode }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上架货位" name="second">
          <el-table
            :data="shelvesOrderInfo && shelvesOrderInfo.shelvesList"
            highlight-current-row
            border
          >
            <el-table-column type="index" fixed align="center" width="60" label="序号"></el-table-column>
            <el-table-column prop="goodsName" min-width="240" align="center" label="商品名称"></el-table-column>
            <el-table-column prop="ysdgProductionTime" width="180" align="center" label="生产日期">
              <template slot-scope="scope">{{scope.row.ysdgProductionTime || '无'}}</template>
            </el-table-column>
            <!-- <el-table-column v-if="userInfo.isMdOpen==1" width="180" align="center" label="有效期至">
              <template slot-scope="scope">
                <span :style="getValidUntil(scope.row.ysdgValidityTime).isPastDue ? 'color:red;':''">{{scope.row.ysdgValidityTime || '-'}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="yaToName" width="180" align="center" label="已上架库区"></el-table-column>
            <el-table-column prop="ylCode" width="180" align="center" label="货位编号"></el-table-column>
            <el-table-column
              prop="ygslNormalNumber"
              width="180"
              align="center"
              :label="'上架数量(件)\n(正常品)'"
            ></el-table-column>
            <el-table-column
              prop="ygslBrokenNumber"
              width="180"
              align="center"
              :label="'上架数量(件)\n(破损品)'"
            ></el-table-column>
            <el-table-column prop="barCode" width="180" align="center" label="商品条码"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="中途出库记录" name="third">
          <el-table
            :data="shelvesOrderInfo && shelvesOrderInfo.stagingOutboundList"
            highlight-current-row
            border
          >
            <el-table-column type="index" fixed align="center" width="60" label="序号"></el-table-column>
            <el-table-column prop="goodsName" min-width="240" align="center" label="商品名称"></el-table-column>
            <el-table-column prop="ysdgProductionTime" width="180" align="center" label="生产日期">
              <template slot-scope="scope">{{scope.row.ysdgProductionTime || '无'}}</template>
            </el-table-column>
            <!-- <el-table-column v-if="userInfo.isMdOpen==1" width="180" align="center" label="有效期至">
              <template slot-scope="scope">
                <span :style="getValidUntil(scope.row.ysdgValidityTime).isPastDue ? 'color:red;':''">{{scope.row.ysdgValidityTime || '-'}}</span>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="ygsoNormalNumber"
              width="180"
              align="center"
              :label="'出库数量(件)\n(正常品)'"
            ></el-table-column>
            <el-table-column
              prop="ygsoBrokenNumber"
              width="180"
              align="center"
              :label="'出库数量(件)\n(破损品)'"
            ></el-table-column>
            <el-table-column prop="ygsoCreateTime" width="180" align="center" label="出库时间"></el-table-column>
            <el-table-column prop="taskCode" width="190" align="center" label="出库任务">
              <template slot-scope="scope">
                <el-button v-if="scope.row.taskCode" type="text" @click="viewTask(scope.row)" size="mini">{{scope.row.taskCode}}</el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="barCode" width="180" align="center" label="商品条码"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import rollsHomework from '@/store/rollsHomework/index'
import {GETSHELVESORDERINFO} from '@/store/rollsHomework/types'
import {SAVETASKPRINTBILLPUTAWAYDATA} from '@/store/assignmentManage/types.js'
// import { parseTime } from '@/utils'
import user from '@/store/user/index'
export default {
  name: 'putawayListDetail',
  props: [],
  data () {
    return {
      pictureList: [
        {url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
      ],
      code: '', // 商品code
      activeName: 'first',
      list: [
        {
          expDays: 1, // 保质期
          name: '碱水面（150g*60包）', // 商品名称
          goodsCode: '31002000901', // 商品编码
          actualWornNum: 100, // 破损品
          actualNum: 150, // 正常品
          box: 20,
          batchList: [
            {
              ytgbId: '', // 批次id
              ytgbProductionTime: '', // 生产日期
              ytgbNormal: '', // 批次正常品
              ytgbBroken: '', // 批次破损品
              validUntil: ''
            },
            {
              ytgbId: '', // 批次id
              ytgbProductionTime: '', // 生产日期
              ytgbNormal: '', // 批次正常品
              ytgbBroken: '', // 批次破损品
              validUntil: ''
            }
          ]
        },
        {
          expDays: 10, // 保质期
          name: '农夫山泉矿泉水', // 商品名称
          goodsCode: '31002000901', // 商品编码
          actualWornNum: 188, // 破损品
          actualNum: 98, // 正常品
          box: 16,
          batchList: [
            {
              ytgbId: '', // 批次id
              ytgbProductionTime: '', // 生产日期
              ytgbNormal: '', // 批次正常品
              ytgbBroken: '', // 批次破损品
              validUntil: ''
            }
          ]
        }
      ]
    }
  },
  computed: {
    // 任务详情数据
    shelvesOrderInfo () {
      return rollsHomework.state.shelvesOrderInfo
    },
    // 用户信息
    userInfo () {
      return user.state.userinfo
    }
  },
  watch: {
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.getList()
      }
    }
  },
  mounted () {
    this.warehouseCode = this.$route.params.warehouseCode
    this.code = this.$route.params.code
    // 获取编辑回显数据
    this.getList()
  },
  methods: {
    // 获取编辑回显数据
    getList () {
      let params = {
        ysdCode: this.code
      }
      this.$store.dispatch(GETSHELVESORDERINFO, params)
    },
    getValidUntil (time) {
      let isPastDue = false
      if (time) {
        // let d1Time = e + ' 23:59:59'
        let d1 = new Date(time.replace('-', '/')).getTime()
        isPastDue = d1 < new Date().getTime()
      } else {
        isPastDue = false
      }

      return {isPastDue}
    },
    // 查看出库任务详情
    viewTask (data) {
      this.$router.push('/assignmentManage/warehouseOutDetail/' + data.taskCode + '/' + 1)
    },
    toPreviewPrint () {
      let goodsListEdit = this.shelvesOrderInfo.goodList
      let goodsSku = goodsListEdit.length
      goodsListEdit.forEach(x => {
        if (!x.batchList || !x.batchList.length) {
          x.ysdgProductionTime = '无'
        }
        if (x.batchList && x.batchList.length) {
          x.batchList.forEach(y => {
            if (!y.ysdgProductionTime) {
              y.ysdgProductionTime = '无'
            }
          })
        }
        if (!x.barCode) {
          x.barCode = ''
        }
      })
      let goodsTotalPiece = ''
      goodsTotalPiece = (this.shelvesOrderInfo.ysdNumber || 0) + '件'
      let newGoodList = goodsListEdit.filter(x => {
        return (!x.batchList) || (!x.batchList.length)
      })
      let newBatchList = goodsListEdit.filter(x => {
        return x.batchList && x.batchList.length
      })
      newBatchList.forEach(item => {
        let one = {goodName: item.goodName, barCode: item.barCode}
        item.batchList.map(info => {
          // 计算箱+件
          this.getBoxNumber(info, item)
          let entire = Object.assign({}, one, info)
          newGoodList.push(entire)
        })
      })
      this.$store.dispatch(SAVETASKPRINTBILLPUTAWAYDATA, {goodsListEdit: newGoodList, goodsTotalPiece, goodsSku}).then(() => {
        this.$router.push(`/rollsHomework/putawayList/putawayPrintTemp/${this.code}/${3}/${this.warehouseCode}`)
      })
    },
    // 计算箱+件
    getBoxNumber (info, item) {
      let list = [
        {key: 'allNumBox', val: 'allNum'},
        {key: 'ysdgInventoryBox', val: 'ysdgInventory'},
        {key: 'ysdgShelvesBox', val: 'ysdgShelves'},
        {key: 'ysdgCancelBox', val: 'ysdgCancel'},
        {key: 'ysdgOutboundBox', val: 'ysdgOutbound'},
        {key: 'brokenAllNumBox', val: 'brokenAllNum'},
        {key: 'ysdgBrokenInventoryBox', val: 'ysdgBrokenInventory'},
        {key: 'ysdgBrokenShelvesBox', val: 'ysdgBrokenShelves'},
        {key: 'ysdgBrokenCancelBox', val: 'ysdgBrokenCancel'},
        {key: 'ysdgBrokenOutboundBox', val: 'ysdgBrokenOutbound'}
      ]
      list.forEach(x => {
        info[x.key] = `${Math.floor(info[x.val] / item.box)}${item.maxUnit}${info[x.val] % item.box}${item.minUnit}`
      })
    }
  }
}
</script>
<style>
.el-tooltip__popper.is-dark {
  opacity: .8;
}
</style>
<style scoped>
  .item {
    width: 200px;
  }
  .head-tit {
    font-size: 20px;
    font-weight: bold;
  }
  .top-tit{
    font-size: 20px;
    padding-bottom: 20px;
    display: flex;
    font-weight: bold;
    align-items: center;
    color: #696969;
  }
  .top-code {
    font-size: 18px;
    line-height: 31px;
    height: 30px;
    overflow: hidden;
  }
  .assignment-content {
    flex-direction: column;
    display: flex;
  }
  .assignment-content label {
    padding: 5px 0;
  }
  .btm-button {
    width: 58%;
    margin-left: auto;
    padding-top: 20px;
  }
  .operation-warp {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #409EFF;
    cursor: pointer;
  }
  .operation-warp div:hover {
    color: #66b1ff;
  }
  .btm-label {
    display: flex;
    flex-direction: column;
  }

  .assignmentedit-List {
    padding-left: 20px;
  }
  .assignmentedit-List >>> .el-table .cell{
    white-space:pre-line;
  }

  .assignment-detail .top-wrap_con {
    position: relative;
  }

  .print-btn {
    position: absolute;
    top: 30px;
    right: 100px;
  }

  .page-content-table{
  overflow: auto;
  /* border: 1px solid #EBEEF5; */
  /* height: calc(100% - 100px); */
  width: 100%;
}
.page-content-head{
  /* background: #f2f2f2; */
  /* height: 45px; */
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  border: 1px solid #EBEEF5;
  color: #909399;
  font-weight: 600;
  box-sizing: border-box;
  font-size: 14px;
  white-space: nowrap;
  width: 1415px;
}
.page-content-body{
  color: #606266;
  box-sizing: border-box;
  font-size: 14px;
  /* height: calc(100% - 70px); */
  width: 1415px;
}
.page-content-body-list{
  width: 100%;
}
.page-content-body-item{
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  width: 100%;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
  box-sizing: border-box;
  white-space: nowrap;
}
.table-td{
  padding: 12px 0;
  /* height: 70px; */
  /* box-sizing: border-box; */
  text-overflow: ellipsis;
  vertical-align: middle;
  text-align: center;
  display: inline-block;
  line-height: 46px;
  height: 46px;
  border-right: 1px solid #EBEEF5;
  /* white-space: pre; */
}
.table-td:last-child {
  border-right: none;
}
.vertical1 {
  width: 45px;
}
.vertical2 {
  width: 130px;
}
.vertical3 {
  width: 100px;
}
.vertical4 {
  width: 100px;
}
.vertical5 {
  line-height: 23px;
  width: 100px;
}
.vertical6 {
  line-height: 23px;
  width: 80px;
}
.vertical6-value{
  color: #409EFF;
}
.vertical7 {
  line-height: 23px;
  width: 80px;
}
.vertical8 {
  line-height: 23px;
  width: 80px;
}
.vertical9 {
  line-height: 23px;
  width: 100px;
}
.vertical10 {
  line-height: 23px;
  width: 100px;
}
.vertical11 {
  line-height: 23px;
  width: 80px;
}
.vertical11-value{
  color: #409EFF;
}
.vertical12 {
  line-height: 23px;
  width: 80px;
}
.vertical13 {
  line-height: 23px;
  width: 80px;
}
.vertical14 {
  line-height: 23px;
  width: 100px;
}
.vertical15 {
  width: 130px;
}
.page-content-body .vertical6,.page-content-body .vertical7, .page-content-body .vertical8,.page-content-body .vertical9, .page-content-body .vertical11,.page-content-body .vertical12,.page-content-body .vertical13,.page-content-body .vertical14{
  line-height: 46px;
}
.date-select.el-date-editor.el-input{
  width: 140px !important;
}
.num-input.el-input{
  width: 100px !important;
}
.print-top-btn {
    position: absolute;
    top: 30px;
    right: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/page/rollsHomework/putawayList/putawayListDetail.vue